import { useSelector } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import {
  getLineColorFunctionMapping,
  getLineWidthFunctionMapping,
  getFillColorFunctionMapping,
  getPointRadiusFunctionMapping,
} from 'components/contexts/LayerStyleReferenceMapping';
import { useAppState } from 'components/contexts/State';
import {
  getFormattedValue,
  getNameFormatterFromColumn,
  getValueFormatterFromColumn,
} from 'components/contexts/ColumnFormatterMapping';

export const CUSTOMSQL_FOURTH_LAYER_ID = 'customSqlFourthLayer';

function CustomSqlFourthLayer() {
  const { customSqlFourthLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, customSqlFourthLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  const { customSqlData } = useAppState();

  if (customSqlFourthLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: CUSTOMSQL_FOURTH_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: customSqlFourthLayer.visible,
      opacity: customSqlFourthLayer.opacity,

      getFillColor: getFillColorFunctionMapping[customSqlFourthLayer.getFillColor]
        ? getFillColorFunctionMapping[customSqlFourthLayer.getFillColor]
        : [0, 0, 0],
      pointRadiusMinPixels: customSqlFourthLayer.pointRadiusMinPixels
        ? customSqlFourthLayer.pointRadiusMinPixels
        : 1,
      getPointRadius: (v) => {
        if (
          customSqlFourthLayer.getFillColor === 'default_point' ||
          customSqlFourthLayer.getFillColor === 'secondary_point' ||
          customSqlFourthLayer.getFillColor === 'tertiary_point'
        )
          return getPointRadiusFunctionMapping.default_point(v);
        return 5;
      },

      getLineColor: getLineColorFunctionMapping[customSqlFourthLayer.getLineColor]
        ? getLineColorFunctionMapping[customSqlFourthLayer.getLineColor]
        : [0, 0, 0],
      lineWidthMinPixels: customSqlFourthLayer.lineWidthMinPixels
        ? customSqlFourthLayer.lineWidthMinPixels
        : 1,
      getLineWidth: (v) => {
        if (
          customSqlFourthLayer.getLineColor === 'default_line' ||
          customSqlFourthLayer.getLineColor === 'secondary_line' ||
          customSqlFourthLayer.getLineColor === 'tertiary_line'
        )
          return getLineWidthFunctionMapping.default_line(v);
        return 1;
      },

      pointType: customSqlFourthLayer.pointType
        ? customSqlFourthLayer.pointType
        : 'circle',

      onDataLoad: (data) => {
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object && info?.object?.properties) {
          const tooltip = customSqlData[3]?.properties?.tooltip;
          const title = tooltip?.title ? tooltip?.title : 'Details';
          let subTitle = tooltip?.subtitle ? tooltip?.subtitle : '';
          let htmlString = '';
          if (tooltip?.columns && tooltip?.columns?.length > 0) {
            if (
              tooltip.subtitle_column &&
              info?.object?.properties[tooltip.subtitle_column]
            ) {
              subTitle = info?.object?.properties[tooltip.subtitle_column];
            }
            htmlString += `<div class="deck-tooltip-title">${title}</div>`;
            if (subTitle) {
              htmlString += `<div class="deck-tooltip-subtitle">${subTitle}</div>`;
            }
            htmlString += `<div class="deck-hr"></div><div class="deck-tooltip-msg-container">`;
            tooltip.columns.forEach((column) => {
              htmlString += `<div class="deck-tooltip-msg-wrapper"><div class="deck-tooltip-msg-text-1">${
                getNameFormatterFromColumn(source?.data, column)
                  ? getNameFormatterFromColumn(source?.data, column)
                  : column.replace(/_/g, ' ')
              }</div><div class="deck-tooltip-msg-text-2">`;
              htmlString += getValueFormatterFromColumn(source?.data, column)
                ? new Function(
                    'return ' + getValueFormatterFromColumn(source?.data, column)
                  )()(info?.object?.properties[column])
                : getFormattedValue(info?.object?.properties[column]);
              htmlString += `</div></div>`;
            });
            htmlString += `</div>`;
          }
          info.object = { html: htmlString };
        }
      },
    });
  }
}

export default CustomSqlFourthLayer;
